import { textFilter } from "react-bootstrap-table2-filter";
import {
  DeepMergeObject,
  DotStringToObject,
  GetHeaderStyle,
  GetNormalStyle,
  Post,
  PostJson,
} from "../core/Helper";

export const StaffFields = {
  PrefixId: 0,
  StaffCode: null,
  StaffType: null,
  StaffTypeId: -1,
  Staffid: -1,
  GendId: 0,
  Prefix: null,
  AcceptLineMessage: true,
  BirthDate: null,
  BrchId: -1,
  Email: null,
  FirstName: null,
  FullFirstName: null,
  ImageName: null,
  LastName: null,
  LineId: null,
  LineInfo: null,
  MobileNo: null,
  NickName: null,
};

export class StaffService {
  static async GetStaffNew(data, user) {
    let result = await PostJson("api/staff-new/getitem", { data, user });
    return result ?? null;
  }

  static async GetList(params) {
    let result = await Post("api/user/get-list", params);
    return result ?? null;
  }
  static async GetListData(params) {
    let result = await Post("api/staff/select", params);
    return result ?? null;
  }

  static async GetData(params) {
    let result = await Post("api/staff/get-data", params);
    return result ?? null;
  }

  static async DeleteStaff(params) {
    let result = await Post("api/staff/delete", params);
    return result ?? null;
  }

  static async SaveFromUpload(params) {
    let result = await Post("api/staff/SaveFromUpload", params);
    return result ?? null;
  }

  static async GetComponents(params) {
    let result = await Post("api/staff/getComponents", params);
    return result ?? null;
  }

  static async StaffUpdate(params) {
    let result = await Post("api/staff/update", params);
    return result ?? null;
  }

  // SearchB components
}

export const SearchRadi = (props) => {
  const [setSearchB, data, setData, userInfo, item, isPhysician] = props;

  //** ชื่อฟิลด์ data สำหรับรับข้อมูล */
  const idFieldName = "staffid";
  const displayFieldName = "staff_name";

  setSearchB({
    title: "รังสีแพทย์",
    size: "lg",
    show: true,
    fieldId: idFieldName,
    fieldName: "staff_name",
    sql: {
      fields: [
        "staffid",
        "staffcode",
        "concat('พ.', a.firstname, ' ', a.lastname) as staff_name",
      ],
      tableName: `ba_staff a inner join ba_staff_type  b on a.stafftypeid = b.stafftypeid and 
        ${
          !isPhysician
            ? " b.flag_radi = 'y' and b.flag_radi_dummy = 'n' "
            : "b.flag_physician='y'"
        }`,
      defaultCriteria: ` a.del_flag ='n' ${
        !isPhysician ? "" : " and a.brchid=" + userInfo?.brchid
      } `,
      criteriaFields: ["a.staffcode", "a.firstname", "a.lastname"],
      criteriaText: "",
      orderBy: ["a.staffcode"],
      maxRows: 3000,
    },
    /** เมื่อคลิกเลือกรายการ */
    action: (result) => {
      setData((pv) => ({
        ...pv,
        ...DeepMergeObject(
          DotStringToObject(
            item.fieldName + "." + item.searchValueName,
            result[idFieldName]
          ),
          DotStringToObject(
            item.fieldName + "." + item.searchDisplayName,
            result[displayFieldName]
          )
        ),
      }));
      setSearchB((pv) => ({ ...pv, show: false }));
    },
    columns: [
      {
        dataField: "staffcode",
        text: "รหัส",
        sort: true,
        headerStyle: GetHeaderStyle("120px"),
        style: () => GetNormalStyle("center"),
        filter: textFilter({ placeholder: "..." }),
      },
      {
        dataField: "staff_name",
        text: "ชื่อ-สกุล แพทย์",
        sort: true,
        headerStyle: GetHeaderStyle("auto"),
        style: () => GetNormalStyle("left"),
        filter: textFilter({ placeholder: "..." }),
      },
    ],
  });
};

export const RadiMiniColumns = [
  {
    dataField: "prefix",
    // isDummyField: true,
    text: "ประเภท",
    sort: true,
    headerStyle: GetHeaderStyle("80px"),
    style: () => GetNormalStyle("left"),
    // formatter: (cell, row) => (
    //   <span>{`${row.firstname} ${row.lastname} (${row.prefix})`}</span>
    // ),
    filter: textFilter({ placeholder: "..." }),
  },
  {
    dataField: "firstname",
    text: "ชื่อแพทย์",
    sort: true,
    headerStyle: GetHeaderStyle("auto"),
    style: () => GetNormalStyle("left"),
    filter: textFilter({ placeholder: "..." }),
  },
  {
    dataField: "lastname",
    text: "สกุล",
    sort: true,
    headerStyle: GetHeaderStyle("auto"),
    style: () => GetNormalStyle("left"),
    filter: textFilter({ placeholder: "..." }),
  },
];
